(function () {
  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function init() {
    // Only run on pages that have an "Offre" variant option (single / lot selector).
    var hasOffre = document.querySelector('input[name="Offre"], select[name="options[Offre]"]');
    if (!hasOffre) return;

    // Avoid double-inserting if this script ever runs twice.
    if (document.querySelector('[data-lot-color-picker]')) return;

    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    // NOTE: form.id can be shadowed by a child input named "id" (Dawn's hidden
    // variant-id field), which is a known HTMLFormElement quirk. Always read
    // the id via getAttribute to get the real string value.
    var formIdAttr = form ? form.getAttribute('id') : null;
    if (!form || !formIdAttr) return;

    fetch(window.location.pathname.replace(/\/$/, '') + '.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res && res.ok ? res.json() : null;
      })
      .then(function (productData) {
        if (!productData || !productData.options) return;
        var couleurOption = productData.options.filter(function (opt) {
          return opt.name === 'Couleur';
        })[0];
        if (!couleurOption || !couleurOption.values || !couleurOption.values.length) return;
        buildPicker(form, formIdAttr, couleurOption.values);
      })
      .catch(function () {});
  }

  function buildPicker(form, formId, colorValues) {
    var offreField = document.querySelector('input[name="Offre"]');
    var offreContainer = offreField
      ? offreField.closest('fieldset') || offreField.closest('.product-form__input')
      : null;

    if (!offreContainer) {
      var offreSelect = document.querySelector('select[name="options[Offre]"]');
      offreContainer = offreSelect ? offreSelect.closest('.product-form__input') : null;
    }

    if (!offreContainer || !offreContainer.parentNode) return;

    var container = document.createElement('div');
    container.setAttribute('data-lot-color-picker', '');
    container.className = 'product-form__input lot-color-picker';
    container.hidden = true;

    var title = document.createElement('p');
    title.className = 'form__label lot-color-picker__title';
    title.textContent = 'Choisissez la couleur de chacun des 3 soutiens-gorge du lot';
    container.appendChild(title);

    var selects = [];

    for (var i = 1; i <= 3; i++) {
      var wrapper = document.createElement('div');
      wrapper.className = 'product-form__input product-form__input--dropdown lot-color-picker__item';

      var label = document.createElement('label');
      label.className = 'form__label';
      label.setAttribute('for', 'LotColor-' + formId + '-' + i);
      label.textContent = 'Soutien-gorge ' + i;

      var selectWrap = document.createElement('div');
      selectWrap.className = 'select';

      var select = document.createElement('select');
      select.id = 'LotColor-' + formId + '-' + i;
      select.className = 'select__select';
      select.name = 'properties[Couleur - Soutien-gorge ' + i + ']';
      select.setAttribute('form', formId);

      var emptyOption = document.createElement('option');
      emptyOption.value = '';
      emptyOption.textContent = 'Choisir une couleur';
      select.appendChild(emptyOption);

      colorValues.forEach(function (value) {
        var option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        select.appendChild(option);
      });

      selectWrap.appendChild(select);
      wrapper.appendChild(label);
      wrapper.appendChild(selectWrap);
      container.appendChild(wrapper);
      selects.push(select);
    }

    offreContainer.parentNode.insertBefore(container, offreContainer.nextSibling);

    function getSelectedOffre() {
      var checkedRadio = document.querySelector('input[name="Offre"]:checked');
      if (checkedRadio) return checkedRadio.value;
      var dropdown = document.querySelector('select[name="options[Offre]"]');
      if (dropdown) return dropdown.value;
      return '';
    }

    function isLotOffer(value) {
      return typeof value === 'string' && value.toLowerCase().indexOf('lot') !== -1;
    }

    function refresh() {
      var offre = getSelectedOffre();
      if (isLotOffer(offre)) {
        container.hidden = false;
        selects.forEach(function (select) {
          select.disabled = false;
          select.setAttribute('required', 'required');
        });
      } else {
        container.hidden = true;
        selects.forEach(function (select) {
          select.value = '';
          select.removeAttribute('required');
          // Disabled fields are excluded from FormData, so a single-item
          // purchase never submits these (otherwise empty) properties.
          select.disabled = true;
        });
      }
    }

    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || !target.name) return;
      if (target.name === 'Offre' || target.name === 'options[Offre]') {
        refresh();
      }
    });

    refresh();
  }

  onReady(init);
})();
